import React from 'react';
import { TextField, Checkbox } from 'material-ui';
import { Link } from 'react-router';
import RaisedButton from '../../tc-ui/raised-button-with-loader';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: props.loginEmail || '',
      password: '',
      associateEmail: props.associateEmail,
      companyType: props.viewAs,
    }
  }
  login = () => {
    this.props.login(this.state);
  };
  render() {
    const { email, emailErrorText, password, passwordErrorText } = this.state;
    const submitButton = (() => {
      if (this.props.sending) return <RaisedButton data-cy="signin-loading" style={{ width: '100%', marginTop: '32px' }} label="Logging you in..." className={'signin-button loader'} disabled/>;
      return <RaisedButton style={{ width: '100%', marginTop: '32px' }} secondary onClick={this.login} label="Log in" className={'signin-button-clicker'}/>;
    })();
    const { ratesOrRequests } = this.props;
    return (
      <div>
        {
         Boolean(this.props.associateEmail) && (
           <div style={{ fontWeight: '300' }}>
             By logging in below, you will be adding {this.props.associateEmail}, and the {ratesOrRequests} sent to that email, to your account.
           </div>
         )
        }
        <TextField
          style={{ width: '100%' }}
          floatingLabelText="Email"
          value={email}
          disabled={Boolean(this.props.loginEmail)}
          hintText="Required"
          errorText={emailErrorText}
          onChange={(_, val) => {
            if (this.props.loginError) this.props.updateDialogProps({ loginError: null });
            this.setState({
              emailErrorText: emailErrorText ? '' : emailErrorText,
              email: val,
            });
          }}
          className="singin-email"
        />
        <TextField
          style={{ width: '100%' }}
          floatingLabelText="Password"
          value={password}
          hintText="Required"
          errorText={passwordErrorText}
          onChange={(_, val) => {
            if (this.props.loginError) this.props.updateDialogProps({ loginError: null });
            this.setState({
              passwordErrorText: passwordErrorText ? '' : passwordErrorText,
              password: val,
            });
          }}
          type="password"
          className="singin-password"
        />
        {
          Boolean(this.props.associateEmail) && (
            <div style={{ marginTop: '24px' }}>
              <Checkbox
                checked
                disabled
                data-cy="associateEmail"
                labelStyle={{ color: 'black' }}
                label={`Add ${this.props.associateEmail} as an Associated Email, and the ${ratesOrRequests} sent to that email, to your account.`}
              />
              <Link
                style={{ textDecoration: 'underline', fontSize: '12px', marginLeft: '40px', cursor: 'pointer' }}
                onClick={this.props.openHelpWidget}
                to={`${window.location.href}&helpText=associatedemail`}
              >
                What does this mean?
              </Link>
            </div>
          )
        }
        {
          Boolean(this.props.loginError) && (
            <div style={{ marginTop: '16px', paddingLeft: '12px', color: 'red' }} data-cy="loginError">
              {this.props.loginError}
            </div>
          )
        }
        {submitButton}
      </div>
    )
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/login.jsx